import { Routes } from '@angular/router';
import { SettingsComponent } from './settings.component';
import { OrganizationSetupComponent } from './organization-setup/organization-setup.component';
import { PeopleComponent } from './people/people.component';
import { TagsComponent } from './tags/tags.component';
import { DocumentTypesComponent } from './documents/document-types/document-types.component';
import { DocumentStatusComponent } from './documents/document-status/documents-status.component';
import { DocumentMilestoneComponent } from './documents/document-milestone/document-milestone.component';
import { DocumentTagsComponent } from './documents/document-tags.component';
import { ProjectStatusComponent } from './project-settings/project-status/project-status.component';
import { ProjectMilestoneComponent } from './project-settings/project-milestone/project-milestone.component';
import { ChecklistsComponent } from './checklists-and-risks/checklists/checklists.component';
import { RisksComponent } from './checklists-and-risks/risks/risks.component';
import { FilesComponent } from './knowledgebase/files/files.component';
import { KnowledgeBaseStoreComponent } from './knowledgebase/knowledge-base-store/knowledge-base-store.component';
import { KnowledgeMappingComponent } from './knowledgebase/knowledge-mapping/knowledge-mapping.component';
import { QnAPairComponent } from './innform/qna-pair/qna-pair.component';
import { ReviewTabsComponent } from './innform/qna-pair/review-tabs/review-tabs.component';
import { ReviewQnaComponent } from './innform/qna-pair/review-qna/review-qna.component';
import { DuplicateQnaComponent } from './innform/qna-pair/duplicate-qna/duplicate-qna.component';
import { InnformAttachmentsComponent } from './innform/innform-attachments/innform-attachments.component';
import { ClauseLibraryComponent } from './library/clause-library/clause-library.component';
import { ClauseLibraryReviewTabsComponent } from './library/clause-library/review-tabs/clause-library-review-tabs.component';
import { ReviewClausesComponent } from './library/clause-library/review-tabs/review-clauses/review-clauses.component';
import { DuplicateClausesComponent } from './library/clause-library/review-tabs/duplicate-clauses/duplicate-clauses.component';
import { TemplateLibraryComponent } from './library/template-library/template-library.component';
import { USER_ROLE } from '../../../@core/models/enums';
import { SHARE_ACCESS } from '../../../@core/models/model';
import { PermissionGuard } from '../../../@core/guards/permission.guard';
import { ProjectTagsComponent } from './project-settings/projects-tags/project-tags.component';
import { SubscriptionGuard } from '../../../@core/guards/subscription.guard';
import { IntegrationsComponent } from '../integrations/integrations.component';
import { CreditUsageComponent } from 'src/app/features/credits/components/credit-usage/credit-usage.component';
import { BillingInvoicesComponent } from './billing-invoices/billing-invoices.component';

export const SETTINGS_ROUTES: Routes = [
    {
        path: '',
        component: SettingsComponent,
        canActivate: [SubscriptionGuard],
        data: { breadcrumb: 'Settings' },
        children: [
            { path: '', redirectTo: 'organization-setup', pathMatch: 'full' },
            {
                path: 'organization-setup',
                component: OrganizationSetupComponent,
                data: { breadcrumb: 'Organization Setup' }
            },
            {
                path: 'credit-usage',
                component: CreditUsageComponent,
                data: { breadcrumb: 'Credit Usage' }
            },
            {
                path: 'billing-invoices',
                component: BillingInvoicesComponent,
                data: { breadcrumb: 'Billing & Invoices' }
            },
            {
                path: 'people',
                component: PeopleComponent,
                data: { breadcrumb: 'People' },
                children: [
                    { path: '', redirectTo: 'users', pathMatch: 'full' },
                    {
                        path: 'users',
                        component: PeopleComponent,
                        data: { breadcrumb: 'Users' }
                    },
                    {
                        path: 'invites',
                        component: PeopleComponent,
                        data: { breadcrumb: 'Invites', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN] },
                        canActivate: [PermissionGuard]
                    },
                    {
                        path: 'requests',
                        component: PeopleComponent,
                        data: { breadcrumb: 'Requests', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN] },
                        canActivate: [PermissionGuard]
                    }
                ]
            },
            {
                path: 'tags',
                component: TagsComponent,
                data: { breadcrumb: 'Tags', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN] },
                canActivate: [PermissionGuard]
            },
            {
                path: 'documents',
                data: { breadcrumb: 'Documents', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN] },
                children: [
                    { path: '', redirectTo: 'document-types', pathMatch: 'full' },
                    {
                        path: 'document-types',
                        component: DocumentTypesComponent,
                        data: { breadcrumb: 'Document Types' }
                    },
                    {
                        path: 'status',
                        component: DocumentStatusComponent,
                        data: { breadcrumb: 'Status' }
                    },
                    {
                        path: 'milestones',
                        component: DocumentMilestoneComponent,
                        data: { breadcrumb: 'Milestones' }
                    },
                    {
                        path: 'tags',
                        component: DocumentTagsComponent,
                        data: { breadcrumb: 'Tags' }
                    },
                ],
                canActivate: [PermissionGuard]
            },
            {
                path: 'projects',
                data: { breadcrumb: 'Projects', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN] },
                children: [
                    { path: '', redirectTo: 'status', pathMatch: 'full' },
                    {
                        path: 'status',
                        component: ProjectStatusComponent,
                        data: { breadcrumb: 'Status' }
                    },
                    {
                        path: 'milestones',
                        component: ProjectMilestoneComponent,
                        data: { breadcrumb: 'Milestones' }
                    },
                    {
                        path: 'tags',
                        component: ProjectTagsComponent,
                        data: { breadcrumb: 'Tags' }
                    }
                ],
                canActivate: [PermissionGuard]
            },
            {
                path: 'checklists-and-risks',
                data: { breadcrumb: 'Checklists & Risks', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN] },
                children: [
                    { path: '', redirectTo: 'checklists', pathMatch: 'full' },
                    {
                        path: 'checklists',
                        component: ChecklistsComponent,
                        data: { breadcrumb: 'Checklists' }
                    },
                    {
                        path: 'risks',
                        component: RisksComponent,
                        data: { breadcrumb: 'Risks' }
                    },
                ],
                canActivate: [PermissionGuard]
            },
            {
                path: 'repository',
                data: { breadcrumb: 'Repository', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN] },
                children: [
                    { path: '', redirectTo: 'files', pathMatch: 'full' },
                    {
                        path: 'files',
                        component: FilesComponent,
                        data: { breadcrumb: 'Files' }
                    },
                    {
                        path: 'knowledge-base',
                        component: KnowledgeBaseStoreComponent,
                        data: { breadcrumb: 'Knowledge Base' }
                    },
                    {
                        path: 'knowledge-mapping',
                        component: KnowledgeMappingComponent,
                        data: { breadcrumb: 'Knowledge Mapping' }
                    }
                ],
                canActivate: [PermissionGuard]
            },
            {
                path: 'innform',
                data: { breadcrumb: 'InnForm', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN] },
                children: [
                    { path: '', redirectTo: 'qa-pair', pathMatch: 'full' },
                    {
                        path: 'qa-pair',
                        component: QnAPairComponent,
                        data: { breadcrumb: 'QA Pair' },
                        children: [
                            {
                                path: 'review-tabs',
                                component: ReviewTabsComponent,
                                data: { breadcrumb: 'Review' },
                                children: [
                                    { path: '', redirectTo: 'review-qna', pathMatch: 'full' },
                                    {
                                        path: 'review-qna',
                                        component: ReviewQnaComponent,
                                        data: { breadcrumb: 'Review QnA' }
                                    },
                                    {
                                        path: 'review-duplicate',
                                        component: DuplicateQnaComponent,
                                        data: { breadcrumb: 'Review Duplicates' }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'attachments',
                        component: InnformAttachmentsComponent,
                        data: { breadcrumb: 'Attachments' }
                    },
                ],
                canActivate: [PermissionGuard]
            },
            {
                path: 'library',
                data: { breadcrumb: 'Library settings', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN] },
                children: [
                    { path: '', redirectTo: 'clause-library', pathMatch: 'full' },
                    {
                        path: 'clause-library',
                        component: ClauseLibraryComponent,
                        data: { breadcrumb: 'Clause library' },
                        children: [
                            {
                                path: 'review-tabs',
                                component: ClauseLibraryReviewTabsComponent,
                                data: { breadcrumb: 'Review Clauses' },
                                children: [
                                    { path: '', redirectTo: 'review-clauses', pathMatch: 'full' },
                                    {
                                        path: 'review-clauses',
                                        component: ReviewClausesComponent,
                                        data: { breadcrumb: 'Review List' }
                                    },
                                    {
                                        path: 'duplicate-clauses',
                                        component: DuplicateClausesComponent,
                                        data: { breadcrumb: 'Duplicate Clauses' }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'template-library',
                        component: TemplateLibraryComponent,
                        data: { breadcrumb: 'Template library' }
                    }
                ],
                canActivate: [PermissionGuard]
            },
            {
                path: 'integrations',
                component: IntegrationsComponent,
                data: { breadcrumb: 'Integrations', roles: [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN, USER_ROLE.MEMBER], workspaceRoles: [SHARE_ACCESS.OWNER, SHARE_ACCESS.ADMIN, SHARE_ACCESS.VIEW, SHARE_ACCESS.COMMENT, SHARE_ACCESS.EDIT] },
                children: [
                    {
                        path: 'docu-sign',
                        component: IntegrationsComponent,
                        data: { breadcrumb: 'DocuSign' }
                    },
                    {
                        path: 'adobe-sign',
                        component: IntegrationsComponent,
                        data: { breadcrumb: 'Adobe Sign' }
                    },
                    {
                        path: 'callback/:connectorToolkit',
                        component: IntegrationsComponent,
                    }
                ],
                canActivate: [PermissionGuard]
            }
        ]
    }
];

